import React, { useState } from "react";
import "./AddTransactionFile.css";
import FileIcon from "../assets/Icons/file.svg";
import DeleteFileIcon from "../assets/Icons/deleteImg.svg";
import AddTransactionFileModal from "./Modal/AddTransactionFileModal";
import moment from "moment/moment";
import NoDataFound from "../NoDataFound/NoDataFound";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import ConfirmationModal from "../../../components/Common/ConfirmationModal/ConfirmationModal";
const AddTransactionFile = ({
  files,
  setFiles,
  DealId,
  isUpdate,
  isBtnDisable,
  Toggler,
  ToggleComponents,
}) => {
  const [modalStatus, setModalStatus] = useState(false);
  const [toggleTransactions, setToggleTransactions] = useState(false);
  const dateConverter = (timeEnd) => {
    const startDate = new Date().toISOString();
    const newStartDate = new Date(startDate);
    const newEndDate = new Date(timeEnd);
    let result = moment(newStartDate).diff(newEndDate, "days");

    return result;
  };
  const [myIndex, setIndex] = useState(-1);
  const [DeleteDialog, setDeleteDialog] = useState(false);
  const handleOpenDeleteDialog = () => {
    setDeleteDialog(true);
  };
  const handleCloseDeleteDialog = async (del) => {
    setDeleteDialog(false);
    if (del === true) {
      let myIndexTempElement = files[myIndex];

      files.splice(myIndex, 1);

      setFiles(files);

      if (myIndexTempElement.hasOwnProperty("id")) {
        // const id = myIndexTempElement.id;
        // await deleteDoc(doc(db, "deals", dealId, "visits", id));
      }
      setDeleteDialog(false);
    }
  };
  return (
    <>
      <ConfirmationModal
        title={"Delete Confirmation"}
        description={"Are you sure you want to delete this file?"}
        openDialog={DeleteDialog}
        handleCloseDialog={handleCloseDeleteDialog}
      />
      <AddTransactionFileModal
        {...{
          modalStatus,
          setModalStatus,
          files,
          setFiles,
          DealId,
        }}
      />
      <div
        className={`transaction-file-card  ${
          isBtnDisable === true && "custom-disable-card"
        }`}
      >
        <div className="transaction-file-card-content">
          <div
            className="transaction-file-card-header"
            onClick={() => {
              if (isBtnDisable === false) {
                setModalStatus(true);
              }
            }}
          >
            <p className="transaction-file-card-title">Add Files</p>

            <svg
              width={13}
              height={13}
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.533 8.96875V6.21875M7.875 7.59375H5.125"
                stroke="white"
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 5.95V9.25C12 11.45 11.45 12 9.25 12H3.75C1.55 12 1 11.45 1 9.25V3.75C1 1.55 1.55 1 3.75 1H4.575C5.4 1 5.5815 1.242 5.895 1.66L6.72 2.76C6.929 3.035 7.05 3.2 7.6 3.2H9.25C11.45 3.2 12 3.75 12 5.95Z"
                stroke="white"
                strokeMiterlimit={10}
              />
            </svg>
          </div>

          <div className="transaction-file-card-body">
            <div className="title-container">
              <div className="left">
                <span className="transaction-file-title">Files</span>
                <span className="tot-files">({files.length} files)</span>
              </div>
              <div className="right">
                <div
                  onClick={() => {
                    // setToggleTransactions(!toggleTransactions);
                    Toggler();
                  }}
                  className={`transaction-toggler  ${
                    !ToggleComponents ? "toggle-active" : " "
                  }  `}
                >
                  <svg
                    width={17}
                    height={9}
                    viewBox="0 0 17 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      opacity="0.8"
                      d="M16.2271 8.0975L9.87105 1.5775C9.12041 0.8075 7.89209 0.8075 7.14145 1.5775L0.7854 8.0975"
                      stroke="#545454"
                      strokeWidth="1.5"
                      strokeMiterlimit={10}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>

            {ToggleComponents && files.length > 0 ? (
              // files.map((file) =>
              <div className="all-transaction-file">
                {files.map((file, index) => (
                  <div className="transaction-file-elements-container">
                    <div className="transaction-file-element">
                      <div className="left">
                        <img src={FileIcon} alt="file" />
                        <div className="file-name-container">
                          <></>
                          <span className="transaction-file-name">
                            {file.name}
                          </span>

                          {isUpdate ? (
                            <span className="file-size">
                              {file.size}kb -{" "}
                              {/* {dateConverter(file.?.toDate())} */}
                              {/* {dateConverter(file.lastModified) === 0
                              ? "Uploaded Today"
                              : dateConverter(file.lastModified) === 1
                              ? dateConverter(file.lastModified) + " Day ago"
                              : dateConverter(file.lastModified) + " Days ago"} */}
                            </span>
                          ) : (
                            <span className="file-size">
                              {file.size}kb -{" "}
                              {/* {dateConverter(file.lastModified) === 0
                             ? "Uploaded Today"
                             : dateConverter(file.lastModified) === 1
                            ? dateConverter(file.lastModified) + " Day ago"
                             : dateConverter(file.lastModified) + " Days ago"} */}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="delete-file-img">
                        <a href={file.url} download={file.name} target="_blank">
                          <FileDownloadOutlinedIcon className="icon-style" />
                        </a>
                        <img
                          src={DeleteFileIcon}
                          alt=""
                          onClick={(e) => {
                            e.stopPropagation();
                            setIndex(index);
                            handleOpenDeleteDialog();
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              ToggleComponents && (
                <div
                  className="add-deal-common-btn"
                  onClick={() => {
                    if (isBtnDisable === false) {
                      setModalStatus(true);
                    }
                  }}
                >
                  <svg
                    width={28}
                    height={27}
                    viewBox="0 0 28 27"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M26.6097 13.2033H1M13.8048 1V26.0067"
                      stroke="#767676"
                      strokeMiterlimit={10}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  <h3>Add File</h3>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AddTransactionFile;
